module.exports = __webpack_public_path__ + "static/media/cover3.cae2fa4e.png";